<template>
  <div>
    <dash-filter
      :options="filterOptions"
      :default="queryString"
      v-model="queryString"
      :loadingList="loadingList"
      :action="action"
      v-if="usersSearchEnabled(permissionIsEnabled)"
    />
    <div class="el-section">
      <emd-card
        class="_highlight_header _header_spaced _footer_spaced_sm"
        noBorder
      >
        <emd-card-header>
          <emd-text
            size="section"
            tag="h2"
            >{{ $t('users.title') }}
          </emd-text>
          <template #actions>
            <router-link
              v-if="permissionIsEnabled('account_staff.invite:create')"
              :to="{ name: 'invites-create' }"
              class="jsModalOpen"
            >
              <jade-button
                variant="primary-solid"
                size="small"
              >
                {{ $t('users.invite') }}
              </jade-button>
            </router-link>
          </template>
        </emd-card-header>

        <emd-card-content customClass="eu-no-padding">
          <div
            v-if="loadingList"
            class="eu-pa_6 eu-align_center"
          >
            <emd-loader :type="'_invert'" />
          </div>
          <div
            v-else
            class="emd-table-responsive"
          >
            <Table
              :fields="fields"
              :items="users.items"
              :toDetail="usersGetEnabled(permissionIsEnabled) && toDetail"
            ></Table>
            <empty-list
              v-if="showEmptyList"
              entity="users"
            ></empty-list>
          </div>
          <pagination
            v-if="!loadingList"
            :pagination="users.pagination"
            :totalShowing="totalItems"
            :type="'list'"
            :action="action"
          ></pagination>
        </emd-card-content>
      </emd-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import {
  EmdCard,
  EmdCardContent,
  EmdCardHeader,
  EmdLoader,
  EmdText
} from 'emerald-vue/src/components'
import Table from '@/components/project/molecules/Table.vue'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import DashFilter from '@/components/project/globals/DashFilter.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import JadeButton from '@/components/jade/JadeButton/index.vue'
import {
  usersGetEnabled,
  usersSearchEnabled
} from '@/actions-permission/users.permissions'

export default {
  name: 'Users',
  components: {
    EmdLoader,
    EmdText,
    EmdCard,
    EmdCardHeader,
    EmdCardContent,
    Table,
    Pagination,
    EmptyList,
    DashFilter,
    JadeButton
  },
  data () {
    return {
      action: 'GET_USERS',
      queryString: {
        size: 30,
        page: 1,
        first_name: '',
        last_name: '',
        email: ''
      },
      fields: [
        {
          id: 'first_name',
          label: 'users.name',
          type: usersGetEnabled(this.permissionIsEnabled) ? 'link' : 'text',
          link: {
            to: 'usersDetail',
            params: { id: 'id' }
          }
        },
        {
          id: 'email',
          label: 'users.email',
          type: 'text'
        },
        {
          id: 'role.value;type.value',
          label: 'users.permission',
          type: 'conditional'
        }
      ],
      toDetail: {
        name: 'usersDetail',
        params: {
          id: 'id'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['users', 'loadingListUsers', 'filterOptionsUsers']),
    loadingList () {
      return this.loadingListUsers
    },
    filterOptions () {
      return this.filterOptionsUsers
    },
    totalItems () {
      return this.users.items.length
    },
    queryParams () {
      return this.$route.query
    },
    showEmptyList () {
      return (
        !this.loadingList &&
        this.users.pagination &&
        this.users.pagination.total_items === 0
      )
    }
  },
  methods: {
    ...mapActions(['GET_USERS']),
    usersGetEnabled,
    usersSearchEnabled,
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  created () {
    this.GET_USERS(this.queryParams)
  }
}
</script>
